<template>
    <div id="mailType4">
        <div class=startingEndPoint>
            <div class="startslipment">
                <div class="tabs_content">
                    <div class="content">
                      <div class="top">
                        <div class="left">
                          <div class="h">发货地</div>
                          <div class="tabs">
                              <div class="prot"  :class="curStartTab==1?'tabActive':''" @click="changeStartTab(1)">
                                    <span>港口（POB）</span>
                              </div>
                              <div class="visit" :class="curStartTab==2?'tabActive':''" @click="changeStartTab(2)">
                                <span>上门提货</span>
                              </div>
                          </div>
                          <div class="subs">
                            <el-form :model="startSlipmentForm" :rules="startSlipmentRuleForm" ref="startSlipmentForm">
                                <div class="prot" v-show="curStartTab==1">
                                    <div class="t">
                                        <div class="h">
                                            <p>港口</p>
                                            <span>* 请输入两个或更多字元</span>
                                            
                                        </div>
                                    </div>
                                    <div class="b">
                                        <el-form-item prop="prot">
                                            <el-input v-model="startSlipmentForm.prot"></el-input>
                                        </el-form-item>
                                        <div class="inclusiveFee" :class="startSlipmentForm.inclusiveFee==1?'selected':''" @click="changeStartInclusiveFee">
                                            <div class="radio">
                                                <span class="el-icon-check"></span>
                                            </div>
                                            <div class="h">是否包含起运费</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="visit"  v-show="curStartTab==2">
                                    <div class="t">
                                        <div class="left">
                                            <!-- 选择框 -->
                                            <div class="h">国家/地区</div>
                                        <el-select v-model="startSlipmentForm.startSlipment" >
                                            <el-option
                                            v-for="item in startSlipmentList"
                                            :key="item.id"
                                            :label="item.country"
                                            :value="item.country">
                                            <div>
                                                <span style="margin-right: 10px;font-size: 18px;" :class="item.icon"></span>
                                                <span>{{item.country}}</span>
                                            </div>
                                            </el-option>
                                        </el-select>
                                        </div>
                                        <div class="right">
                                            <div class="h">城市或邮政编码</div>
                                            <div class="b">
                                                <el-form-item prop="cityCode">
                                                    <el-input v-model="startSlipmentForm.cityCode"></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b">
                                        <div class="inclusiveFee" :class="startSlipmentForm.inclusiveFee==1?'selected':''" @click="changeStartInclusiveFee">
                                            <div class="radio">
                                                <span class="el-icon-check"></span>
                                            </div>
                                            <div class="h">是否包含起运费</div>
                                        </div>
                                    </div>
                                </div>
                            </el-form>
                          </div>
                        </div>
                        <div class="changeBtn">
                          <span class="el-icon-refresh"></span>
                        </div>
                        <div class="right">
                            <div class="h">目的</div>
                            <div class="tabs">
                                <div class="prot"  :class="curEndTab==1?'tabActive':''" @click="changeEndTab(1)">
                                      <span>港口（POB）</span>
                                </div>
                                <div class="visit" :class="curEndTab==2?'tabActive':''" @click="changeEndTab(2)">
                                  <span>上门提货</span>
                                </div>
                            </div>
                            <div class="subs">
                              <el-form :model="endSlipmentForm" :rules="endSlipmentRuleForm" ref="endSlipmentForm">
                                  <div class="prot" v-show="curEndTab==1">
                                      <div class="t">
                                          <div class="h">
                                              <p>港口</p>
                                              <span>* 请输入两个或更多字元</span>
                                          </div>
                                      </div>
                                      <div class="b">
                                          <el-form-item prop="prot">
                                              <el-input v-model="endSlipmentForm.prot"></el-input>
                                          </el-form-item>
                                          <div class="inclusiveFee" :class="endSlipmentForm.inclusiveFee==1?'selected':''" @click="changeEndInclusiveFee">
                                              <div class="radio">
                                                  <span class="el-icon-check"></span>
                                              </div>
                                              <div class="h">是否包含起运费</div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="visit"  v-show="curEndTab==2">
                                      <div class="t">
                                          <div class="left">
                                              <!-- 选择框 -->
                                              <div class="h">国家/地区</div>
                                          <el-select v-model="endSlipmentForm.startSlipment" >
                                              <el-option
                                              v-for="item in startSlipmentList"
                                              :key="item.id"
                                              :label="item.country"
                                              :value="item.country">
                                              <div>
                                                  <span style="margin-right: 10px;font-size: 18px;" :class="item.icon"></span>
                                                  <span>{{item.country}}</span>
                                              </div>
                                              </el-option>
                                          </el-select>
                                          </div>
                                          <div class="right">
                                              <div class="h">城市或邮政编码</div>
                                              <div class="b">
                                                  <el-form-item prop="cityCode">
                                                      <el-input v-model="endSlipmentForm.cityCode"></el-input>
                                                  </el-form-item>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="b">
                                          <div class="inclusiveFee" :class="endSlipmentForm.inclusiveFee==1?'selected':''" @click="changeEndInclusiveFee">
                                              <div class="radio">
                                                  <span class="el-icon-check"></span>
                                              </div>
                                              <div class="h">没有装卸平毫米</div>
                                          </div>
                                      </div>
                                  </div>
                              </el-form>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
        <BoxList/>
        <div class="size">
            <Size boxType="04"/>
        </div>
    </div>
</template>

<script>
// 引人组件
import Size from "@/components/Size"
import {mapState,mapMutations} from 'vuex'
import BoxList from "@/views/Mail/BoxList/BoxList"
export default {
    mame:'',
    components:{
        Size,
        BoxList
    },
    data() {
        return {
            // 当前发货地选中的Tab
            curStartTab:2,
            // 当前目的地选中的Tab
            curEndTab:2,
            // 当前收货地选中的Tab
            curEndTab:1,
            // 发货地表单
            startSlipmentForm:{
                startSlipment:'',
                prot:'',
                cityCode:'',
                inclusiveFee:0,
            },
            // 发货地表单规则
            startSlipmentRuleForm:{
                prot:[
                {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ],
                cityCode:[
                {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ],
            },
            // 目的地表单
            endSlipmentForm:{
                startSlipment:'',
                prot:'',
                cityCode:'',
                inclusiveFee:0,
            },
            // 目的地表单规则
            endSlipmentRuleForm:{
                prot:[
                {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ],
                cityCode:[
                {retuired:true,message:'* 必需填寫。',tirgger:'blur'}
                ],
            },
            // 发货地选项
            endSlipmentList:[
                ],
            // 收货地选项
            startSlipmentList:[
            ],
        }
    },
    mounted() {
    },
    methods: {
        ...mapMutations(["INCREMENTLETTERNUM","DECREMENTLETTERNUM"]),
        // 监听用户点击发货地的tab
        changeStartTab(index){
            this.curStartTab = index
        },
        // 监听用户点击目的地的tab
        changeEndTab(index){
            this.curEndTab = index
        },
        // 监听用户点击发货地包含运费按钮
        changeStartInclusiveFee(){
            if(this.startSlipmentForm.inclusiveFee) return this.startSlipmentForm.inclusiveFee = 0;
            this.startSlipmentForm.inclusiveFee = 1
        },
        // 监听用户点击目的地包含运费按钮
        changeEndInclusiveFee(){
            if(this.endSlipmentForm.inclusiveFee) return this.endSlipmentForm.inclusiveFee = 0;
            this.endSlipmentForm.inclusiveFee = 1
        }
    },
    computed:{
        // 映射状态
        ...mapState({"letterNum":state=>state.mail.letterNum})
    }
}
</script>

<style lang="less" scoped>
 .size{
     margin-top: 70px;
 }
 .startingEndPoint{
     border-bottom: 2px solid #e0e0e0;
     padding-bottom: 50px;
 }
    .top{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .el-select{
            width: 575px;
            box-shadow: 3px 4px 2px #ccc;
            border-radius: 5px;
            border: none;
        }
        input{
            height: 56px !important;
        }
        .h{
            margin-bottom: 20px;
            font-size: 17px;
            font-weight: 550;
            span{
                font-weight: 500;
                font-size:12px;
                color:@colorMain;
                margin-left:10px;
            }
    }
    .left,.right{
        width: 45%;
        .tabs{
            display: flex;
            .prot,
            .visit{
                width: 50%;
                background-color: #f2f2f2;
                height: 55px;
                text-align: center;
                line-height: 55px;
                color: #b4b4b4;
                font-size: 18px;
                &:hover{
                    cursor: pointer;
                    opacity: .8;
                }
            }
            .prot{
                border-top-left-radius:5px ;
                border-bottom-left-radius:5px ;
            }
            .visit{
                border-top-right-radius:5px ;
                border-bottom-right-radius:5px ;
            }
            .tabActive{
                background-color: @colorMain;
                color: #fff;
            }
        }
        .subs{
            margin-top: 30px;
            .prot,.visit{
                .t{
                    align-items: center;
                    .h{
                        display: flex;
                        align-items: center;
                    }
                    
                }
                .b{
                    .el-input__inner{
                        border: 1px solid #ccc !important;
                    }
                    .inclusiveFee{
                        display: flex;
                        font-size: 17px;
                        align-items: center;
                        align-content: center;
                        &:hover{
                            cursor: pointer;
                        }
                        .h{
                            margin-bottom: 0px;
                            margin-left:5px;
                        }
                        .radio{
                            width: 25px;
                            height: 25px;
                            border-radius:50%;
                            border:1px solid #ccc;
                            text-align: center;
                            line-height: 20px;
                            color:#fff;
                            span{
                                padding-top: 2px;
                                display: none;
                            }
                        }
                    }
                    .inclusiveFee.selected{
                        .radio{
                            background-color: @colorMain;
                            border:1px solid @colorMain;
                            span{
                                display: block;
                            }
                        }
                    }
                }
            }
            .visit{
                .t{
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    .left{
                        .el-select{
                            width: 100%;
                            .shadowSelect()
                        }
                    }
                    .right{
                        .h{
                            margin-bottom: 20px;
                        }
                    }
                }
            }
        }
    }
    .changeBtn{
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: @colorMain;
        text-align: center;
        line-height: 35px;
        color: #fff;
        font-size: 18px;
        margin:0  44px;
        margin-top: 33px;
        &:hover{
            cursor: pointer;
            opacity: .8;
        }
    }
}
/* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>